import { forwardRef } from '@grupoboticario/flora-react-system'
import React from 'react'
import { Button, ButtonProps } from './Button'

/**
 * @deprecated Esta tipagem refere-se a um componente que será descontinuado em futuras Breaking Changes do Flora.
 * @tutorial
 * {@link https://florabook.gb.tech/v2/index.html?path=/docs/core-components-florabutton-guia-de-migra%C3%A7%C3%A3o--page| Acesse o guia de migração} para saber como migrar para a nova versão.
 */
export type IconButtonProps = ButtonProps & {
  icon?: React.ReactElement
  'aria-label': string
}

/**
 * @deprecated Este componente será descontinuado em futuras Breaking Changes do Flora. .
 * @tutorial
 * {@link https://florabook.gb.tech/v2/index.html?path=/docs/core-components-florabutton-guia-de-migra%C3%A7%C3%A3o--page| Acesse o guia de migração} para saber como migrar para a nova versão.
 */
export const IconButton = forwardRef<'button', IconButtonProps>(
  ({ css, ...props }, forwardedRef) => {
    const { icon, children, 'aria-label': ariaLabel, ...rest } = props

    const element = icon || children
    const _children = React.isValidElement(element)
      ? React.cloneElement(element as any, {
          'aria-hidden': true,
          focusable: false,
        })
      : null

    return (
      <Button
        ref={forwardedRef}
        variant="unstyled"
        aria-label={ariaLabel}
        css={{ width: 40, height: 40, ...(css as any) }}
        {...rest}
      >
        {_children}
      </Button>
    )
  },
)
